import clsx from 'clsx'

import { ASSET_PREFIX } from '@/configs/constants'

export const ProvinceImage = ({
  alt,
  image,
  level = 'district',
  className = '',
}: {
  alt?: string
  image: string
  level?: 'district' | 'country'
  provinceId?: string
  className?: string
}) => {
  return (
    <img
      src={`${ASSET_PREFIX}/images/provinsi/${image}`}
      alt={alt}
      className={clsx(
        'rounded',
        level === 'country' ? 'h-[26px] w-[40px]' : 'h-[36px] w-[36px]',
        className
      )}
      loading="lazy"
      data-level={level}
    />
  )
}
